import _CONST from '_config/common/const'

export const CONST = _CONST
export default _CONST